import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/19noouBLhsMa1gnrijnrq1/IMG_4828.jpg', 'https://cdn.magicpatterns.com/uploads/rH48QRDPDHPQQ48CYhX6HM/IMG_4829.jpg', 'https://cdn.magicpatterns.com/uploads/pX91NaL1BBM3qcVKr3iF9t/IMG_4830.jpg', 'https://cdn.magicpatterns.com/uploads/gqFfoZXSDxKgM3ZrxLB6pf/IMG_4831.jpg'];
export function Carousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const {
        clientWidth
      } = scrollRef.current;
      const scrollAmount = direction === 'left' ? -clientWidth : clientWidth;
      scrollRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 px-4 bg-brand-dark overflow-hidden" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center mb-8 text-white uppercase tracking-wide" data-id="element-73">
          Vistazo sobre el <span className="text-accent-base" data-id="element-74">contenido</span>
        </h2>

        <div className="relative group" data-id="element-75">
          {/* Controls */}
          <button onClick={() => scroll('left')} className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-brand-dark/80 text-white p-2 rounded-full backdrop-blur-sm border border-white/10 shadow-lg hover:bg-accent-base transition-colors" data-id="element-76">
            <ChevronLeft className="w-6 h-6" data-id="element-77" />
          </button>

          <button onClick={() => scroll('right')} className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-brand-dark/80 text-white p-2 rounded-full backdrop-blur-sm border border-white/10 shadow-lg hover:bg-accent-base transition-colors" data-id="element-78">
            <ChevronRight className="w-6 h-6" data-id="element-79" />
          </button>

          {/* Scroll Container */}
          <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar gap-4 pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-80">
            {images.map((src, idx) => <div key={idx} className="w-36 md:w-48 snap-center flex-shrink-0 cursor-pointer transition-transform hover:scale-[1.03]" onClick={scrollToBuy} data-id="element-81">
                <img src={src} alt={`Contenido interior ${idx + 1}`} className="w-full h-44 md:h-60 object-cover rounded-lg shadow-lg border border-white/10" data-id="element-82" />
              </div>)}
          </div>

          <p className="text-center text-gray-400 text-sm mt-2" data-id="element-83">
            Deslizá para ver más • Tocá para comprar
          </p>
        </div>
      </div>
    </section>;
}